<template>
	<div class="nav-bar">
		<a :href="url + terms.dashboard.single" class="btn-custom-back"
			>Tilbage</a
		>
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb" style="padding: 0px; margin: 0px">
				<li class="breadcrumb-item">
					<a :href="url + terms.dashboard.single">{{
						terms.dashboard.single_cap
					}}</a>
				</li>
				<li v-if="administration" class="breadcrumb-item">
					<a href="">Administration</a>
				</li>
				<li v-if="previousLink" class="breadcrumb-item">
					<a href="">{{ previousLink }}</a>
				</li>
				<li v-if="activeLink" class="breadcrumb-item active">
					<a href="">{{ activeLink }}</a>
				</li>
			</ol>
		</nav>
	</div>
</template>
<script setup>
import { ref, onBeforeMount, computed } from "vue";
import {
	journalTerm,
	noteTerm,
	studentTerm,
	departmentTerm,
	dashboardTerm,
} from "../../helpers/TermHelper";
import api from "../../../service"
const props = defineProps(["activeLink", "previousLink", "administration"]);
const terms = ref({
	journal: "",
	note: "",
	student: "",
	department: "",
	dashboard: "",
});
const url = ref("");
const activeLink = ref("");
onBeforeMount(async () => {
	url.value = api.defaults.baseURL;
	terms.value = {
		journal: await journalTerm(),
		note: await noteTerm(),
		student: await studentTerm(),
		department: await departmentTerm(),
		dashboard: await dashboardTerm(),
	};
	const term = computed(() => {
		const termKey = props.activeLink.toLowerCase();
		if (termKey in terms.value) {
			console.log(termKey);
			if (termKey === "journal") {
				return `${terms.value[termKey].single_cap} 2.0`;
			}
			return terms.value[termKey].single_cap;
		} else {
			return props.activeLink;
		}
	});
	activeLink.value = term.value;
});
</script>
